import { Component, OnInit } from '@angular/core';

//services
import { HttpTestService } from '../../services/http.service';
import { sessionServices } from '../../services/session.services';

import { quickPayModel } from '../../models/quickpay/quickpay.model';
import {IMyDpOptions} from 'mydatepicker';
import{ AppComponent} from '../../app.component';


@Component({
  selector: 'app-request-manage',
  templateUrl: './myComp.component.html'
})
export class myCompComponent implements OnInit {

  public status : string = "";
  public errorMsg : string = "";
  public successMsg : string = "";
  public sessionData : any;
  public allBillData : any = "";
  public allCategoryData : any = [];
  public allSubData : any = [];
  public quickPayModel : quickPayModel = new quickPayModel;
  public popupopen : boolean = false;
  public viewpopupopen : boolean = false;
  public serviceOn : boolean = false;
  public pdfSaving : boolean = false;
  public viewStatus : string = "";
  public viewDate : any = "";
  public viewDocket : any = "";
  public viewCat : any = "";
  public viewSubCat : any = "";
  public viewDetails : string = "";
  public UserBillData :any = "";
  public monthArr : any = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  public payableData : any = "";
  public captchaView : string = "";
  public registeredUserData : any = "";
  public billFetched : boolean = false;
   public checkSumData : any = "";
   public consumerId : any = "";
   
   
   public barChartOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartLabels:any = [];
  public barChartType:string = 'bar';
  public barChartdoughnutChartType:string = 'doughnut';
  public barChartLegend:boolean = true;
 
  public barChartData:any[] = [
    {data: [], label: 'Consumed Kwh'},
	{data: [], label: 'Billed Kwh'},
	{data: [], label: 'Consumed Kvah'},
	{data: [], label: 'Billed Kvah'}
  ];
  
  public consumedKwhPie:any = [];
  public billedKwhPie : any = [];
  public consumedKvahPie : any = [];
  public billedKvahPie:any = [];
   
   public myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
		disableUntil : { year: new Date().getFullYear(), month: new Date().getMonth()+1, day: new Date().getDate()-1 }
    };

	constructor(public http: HttpTestService,
							public session: sessionServices,
							private appComponent: AppComponent) { }

  ngOnInit() {
	  this.getSession();
	  this.generateCaptcha();
	}
  
  
  //get session details
	getSession = function(){
		this.sessionData = this.session.getSessionDetails();
		if(!this.sessionData.consumerId || this.sessionData.consumerId == '' || this.sessionData.consumerId == undefined){
			this.generateCaptcha();
		}else{
			this.getBillHistory();
		}
	}
	
	
	randomString = function(len, an){
    an = an&&an.toLowerCase();
    var str="", i=0, min=an=="a"?10:0, max=an=="n"?10:62;
    for(;i++<len;){
      var r = Math.random()*(max-min)+min <<0;
      str += String.fromCharCode(r+=r>9?r<36?55:61:48);
    }
    return str;
}
	
	generateCaptcha = function(){
		var self= this;
		self.captchaView = "";
		//var cap = self.randomString(6);
		self.captchaView = self.randomString(3);	
	}
	
	//get consumer details
	getConsumerDetails = function(e){
		var self = this;
		self.serviceOn = true;
		self.otpSend = false;
		self.errorMsg = "";
		self.successMsg = "";
		self.quickPayModel.consumerOtp = "";
		var requestedConsumer = self.quickPayModel.consumerId;
		this.consumerId = requestedConsumer;
		//alert(this.consumerId);
		self.http.getUserDetailsByConsNo(requestedConsumer).subscribe(
			(data) => {
			  self.registeredUserData = data;
			  },
			(error) => {
				self.errorMsg = error;
				self.registeredUserData = "";
			},
			() => {
				if (self.registeredUserData.status === "success") {
					this.appComponent.getBroadCastForMyConsumption(self.registeredUserData.region, self.registeredUserData.businessAreaText)//"Asansol-DPS", "Gopalpur"
					self.getBillHistory();
				} else if(self.registeredUserData.status === "GAYACONSUMERID"){
					self.status = self.registeredUserData.status;
					self.errorMsg = "Service is not available for this number range";
					self.serviceOn = false;
				}
				
				
			}
	);
	}
  
  
  getBillHistory = function(){	
	var self = this;
	// self.serviceOn = true;
	self. billFetched = true; 
	var today :any = new Date();
	var todayDD :any = today.getDate();
	var todayMM :any = today.getMonth() + 1;
	
	var todayYYYY :any = today.getFullYear();
	var tillDate :any = today.setDate(today.getDate() - 180);
	var tillDateDD :any = new Date(tillDate).getDate();
	var tillDateMM :any = new Date(tillDate).getMonth() + 1;
	var tillDateYYYY :any = new Date(tillDate).getFullYear();
	
	if(todayMM<10){todayMM = "0"+todayMM}
	if(tillDateDD<10){tillDateDD = "0"+tillDateDD}
	if(todayDD<10){todayDD = "0"+todayDD}
	if(tillDateMM<10){tillDateMM = "0"+tillDateMM}
	if(!self.sessionData.consumerId || self.sessionData.consumerId == '' || self.sessionData.consumerId == undefined){
		var requestedParams :any = self.quickPayModel.consumerId+"^"+todayYYYY+"-"+todayMM+"-"+todayDD+"^"+tillDateYYYY+"-"+tillDateMM+"-"+tillDateDD;//"2010265374^2018-03-31^2018-01-01"
	}else{
		var requestedParams :any = self.sessionData.consumerId+"^"+todayYYYY+"-"+todayMM+"-"+todayDD+"^"+tillDateYYYY+"-"+tillDateMM+"-"+tillDateDD;//"2010265374^2018-03-31^2018-01-01"
	}
	
	//self.http.getConsumptionHistory(this.consumerId)
	self.http.getPaymentHistory(requestedParams)
		  .subscribe(
			(data) => {
				if(data.status === "NORESPONSEFROMSAP") {
					self.status = data.status;
					self.errorMsg = "Your last 6 months consumption history is not available !";
					self.serviceOn = false;
				}else{
					 self.allBillData = data.billParam;
					}
			  },
			(error) => {
				self.errorMsg = error;
				self.allBillData = "";
			},
			() => {


				// if(self.status === "NORESPONSEFROMSAP") {
				// 	self.errorMsg = "Consumption history not found for this period";
				// 	self.serviceOn = false;
				// }else{
					
				//self.allBillData = "11.04.2018 23 23 0 0 | 10.03.2018 49 49 0 0 | 10.02.2018 49 49 0 0 | 11.01.2018 52 52 0 0";
				if(self.allBillData != ""){
					self.allBillData = (self.allBillData).split(" | ");
				}
				var conkwh = [];
				var conkvah = [];
				var billedkwh = [];
				var billedkvah = [];
				self.barChartLabels = [];
				for(var i =0; i<self.allBillData.length; i++){
					self.barChartLabels.push((self.allBillData[i]).split(" ")[0]);
					conkwh.push((self.allBillData[i]).split(" ")[1]);
					billedkwh.push((self.allBillData[i]).split(" ")[2]);
					conkvah.push((self.allBillData[i]).split(" ")[3]);
					billedkvah.push((self.allBillData[i]).split(" ")[4]);
				}
				
				self.barChartData[0].data = conkwh;
				self.barChartData[1].data = billedkwh;
				self.barChartData[2].data = conkvah;
				self.barChartData[3].data = billedkvah;
				self.consumedKwhPie = conkwh;
				self.billedKwhPie = billedkwh;
				self.consumedKvahPie = conkvah;
				self.billedKvahPie = billedkvah;
				self.serviceOn = false;
			//}
		}		
	);
 }
 
 
 closePopup = function(){
		var self = this;
		self.popupopen = false;
		self.UserBillData = "";
	}

	
	closePopupFull = function(){
		var self = this;
		self.popupopen = false;
		self.UserBillData = "";
		self.allBillData = "";
		self.payableData = "";
		self. billFetched = false;
		self.captchaView = "";
		self.generateCaptcha();		
		self.quickPayModel.consumerId = "";
		self.quickPayModel.reEnterCaptcha = "";
		this.appComponent.getBroadCastForMyConsumption(null,null);
	}
	

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/mycomp/myComp.component.ts